import * as v from 'valibot';

import { EAircraftStatusType } from '#shared';

import { aircraftEventSchema } from './aircraftEvent.schema';
import { histAircraftLocationSchema } from './histAircraftTrail.schema';
import { maoAirportSchema } from './maoAirport.schema';
import { maoCrewDutySchema } from './maoCrewDuty.schema';
import { maoLocationSchema } from './maoLocation.schema';
import { maoMaintenanceSchema } from './maoMaintenance.schema';
import { maoTripSchema } from './maoTrip.schema';
import { fallbackWithIssue } from './valibot.helpers';

import type { AircraftStatus } from '../types';

export const aircraftStatusSchema: v.GenericSchema<AircraftStatus> =
  v.intersect([
    v.object({
      Id: v.number('Aircraft ID is missing'),
      Registration: v.string('Registration is missing'),
      Status: v.string('Status is missing'),
      Events: v.array(aircraftEventSchema, 'Events are missing'),
      CrewDuties: v.array(maoCrewDutySchema, 'Crew duties are missing'),
      Trips: v.array(maoTripSchema, 'Trips are missing'),
      Trip: v.optional(maoTripSchema),
      Maintenances: v.array(maoMaintenanceSchema, 'Maintenances are missing'),
      Location: maoLocationSchema,
      isOnFlight: v.boolean('Flight status is missing'),
      ActiveTrail: fallbackWithIssue(
        v.array(histAircraftLocationSchema),
        [],
        '@WARNING:Active trail data is missing or invalid',
      ),
      closestAirport: v.nullish(maoAirportSchema),
      metaHashes: v.object({
        locationHash: v.string('Location hash is missing'),
        dataHash: v.string('Data hash is missing'),
        trailHash: v.string('Trail hash is missing'),
      }),
    }),
    v.variant('Type', [
      v.object({
        Type: v.literal(EAircraftStatusType.OnGround),
        Airport: v.nullable(maoAirportSchema),
      }),
      v.object({
        Type: v.literal(EAircraftStatusType.OnFly),
        IsOnCase: v.boolean('On case status is missing'),
        IsOnFly: v.boolean('On fly status is missing'),
        IsReturnToBase: v.boolean('Return to base status is missing'),
        TripLegStart: v.nullable(v.string('Trip leg start is missing')),
        TripLegStartUnix: v.nullable(
          v.number('Trip leg start unix is missing'),
        ),
        TripLegEnd: v.nullable(v.string('Trip leg end is missing')),
        TripLegEndUnix: v.nullable(v.number('Trip leg end unix is missing')),
        Direction: v.string('Direction is missing'),
        Airports: v.array(maoAirportSchema, 'Airports are missing'),
      }),
      v.object({
        Type: v.literal(EAircraftStatusType.OnMaintenance),
        Airport: v.nullable(maoAirportSchema),
        MaintenanceType: v.string('Maintenance type is missing'),
        MaintenanceName: v.string('Maintenance name is missing'),
      }),
    ]),
  ]);
